import getConfig from '../../js/settings';
import { library } from '@fortawesome/fontawesome-svg-core';
import * as faSolid from '@fortawesome/free-solid-svg-icons';
import * as faRegular from '@fortawesome/free-regular-svg-icons';
import * as faBrands from '@fortawesome/free-brands-svg-icons';

// Initializes set of icons used in the application adding them to the library
export default function initIcons() {
  var iconMap = {
    solid: faSolid,
    regular: faRegular,
    brands: faBrands
  };
  var ICONS = getConfig('ICONS');
  var _loop = function _loop(lib) {
    ICONS[lib].forEach(function (i) {
      return library.add(iconMap[lib][i]);
    });
  };
  for (var lib in ICONS) {
    _loop(lib);
  }
  return library;
}